import { Box, Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { DateTime } from "luxon";
import { HiOutlineViewGrid } from "react-icons/hi";
import TextsmsOutlinedIcon from "@mui/icons-material/TextsmsOutlined";
import { colors } from "../../data/tokens";

function greeting(): string {
  const hour = DateTime.now().hour;
  if (hour < 12) return "Bom dia";
  if (hour < 18) return "Boa tarde";
  return "Boa noite";
}

// Saudação + data + ações rápidas
export function DashboardHeader() {
  const auth = localStorage.getItem("auth");
  const authJson = auth ? JSON.parse(auth) : null;
  const firstName: string =
    (authJson?.fullName ?? "").split(" ")[0] || "bem-vindo(a)";
  const today = DateTime.now()
    .setLocale("pt-BR")
    .toFormat("cccc, dd 'de' LLLL 'de' yyyy");

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 2,
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2.5,
      }}
    >
      <Box>
        <Typography variant="h5" sx={{ fontWeight: 700, color: colors.primaryDark }}>
          {greeting()}, {firstName} 👋
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {today}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap" }}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          href="/#/users/crud/create"
        >
          Novo sócio
        </Button>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<HiOutlineViewGrid />}
          href="/#/iugu-invoices"
        >
          Faturas Iugu
        </Button>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<TextsmsOutlinedIcon />}
          href="/#/feedbacks/crud"
        >
          Contatos
        </Button>
      </Box>
    </Box>
  );
}
